import { render, staticRenderFns } from "./CustomSearchSelect.vue?vue&type=template&id=aa2a5404"
import script from "./CustomSearchSelect.vue?vue&type=script&lang=js"
export * from "./CustomSearchSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports